import React from "react";

import UserSignin from "../components/UserSignin";

const Signin = () => {
  return <UserSignin />;
};

export default Signin;
